/**
 * Pure-function email confirmation match used by DeleteAccountModal.
 *
 * Case-insensitive, trimmed compare.  Empty inputs never match.
 * Extracted to its own module so the Vitest unit test can target the
 * matcher without rendering React.
 */
export function emailConfirmationMatches(typed: string, account: string): boolean {
  const a = (typed ?? '').trim().toLowerCase()
  const b = (account ?? '').trim().toLowerCase()
  if (!a || !b) return false
  return a === b
}
